var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5188_5638)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.99999 18.3346C5.39749 18.3346 1.66666 14.6038 1.66666 10.0013C1.66666 5.3988 5.39749 1.66797 9.99999 1.66797C14.6025 1.66797 18.3333 5.3988 18.3333 10.0013C18.3333 14.6038 14.6025 18.3346 9.99999 18.3346ZM9.99999 16.668C11.7681 16.668 13.4638 15.9656 14.714 14.7153C15.9643 13.4651 16.6667 11.7694 16.6667 10.0013C16.6667 8.23319 15.9643 6.5375 14.714 5.28726C13.4638 4.03701 11.7681 3.33464 9.99999 3.33464C8.23188 3.33464 6.53619 4.03701 5.28594 5.28726C4.0357 6.5375 3.33332 8.23319 3.33332 10.0013C3.33332 11.7694 4.0357 13.4651 5.28594 14.7153C6.53619 15.9656 8.23188 16.668 9.99999 16.668ZM7.49999 7.5013H9.16666V12.5013H7.49999V7.5013ZM10.8333 7.5013H12.5V12.5013H10.8333V7.5013Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5188_5638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "none"
  })))));
};
export default SvgPause;